module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-tab-header"
  }, [_c('div', {
    staticClass: "block-tab-header__container"
  }, [_c('div', {
    staticClass: "block-tab-header__list"
  }, _vm._l((_vm.props), function(tab, i) {
    return _c('div', {
      staticClass: "block-tab-header__tab"
    }, [_c('div', {
      staticClass: "block-tab-header__tab--button",
      class: {
        active: i === _vm.$store.state.tab
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(i)
        }
      }
    }, [_vm._v(_vm._s(tab.label))])])
  }), 0), _c('div', {
    staticClass: "block-tab-header__list block-tab-header__list--mobile"
  }, _vm._l((_vm.props), function(tab, i) {
    return _c('div', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ({
          el: "#tab",
          duration: 1250,
          easing: [0.445, 0.05, 0.55, 0.95],
          offset: -76,
          cancelable: true,
          x: false,
          y: true
        }),
        expression: "{ el: \"#tab\", duration: 1250, easing: [0.445, 0.05, 0.55, 0.95], offset: -76, cancelable: true, x: false, y: true }"
      }],
      staticClass: "block-tab-header__tab"
    }, [_c('div', {
      staticClass: "block-tab-header__tab--button",
      class: {
        active: i === _vm.$store.state.tab
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(i)
        }
      }
    }, [_vm._v(_vm._s(tab.label))])])
  }), 0), _vm._l((_vm.props), function(tab, i) {
    return _c('div', {
      key: i,
      staticClass: "block-tab-header__content",
      attrs: {
        "id": "tab"
      }
    }, [_c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.$store.state.tab),
        expression: "i === $store.state.tab"
      }],
      staticClass: "block-tab-header__content--box"
    }, [_vm._t("default", null, {
      "content": tab.tab
    })], 2)])], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-106c8746","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-tab-header/block-tab-header.pug
// module id = 577
// module chunks = 1